import React from "react";

const NasaLogo = () => {
  return (
    <div className="nasa-logo">
      <img
        src="https://www.nasa.gov/sites/default/files/thumbnails/image/nasa-logo-web-rgb.png"
        alt="nasa-logo"
      />
    </div>
  );
};

export default NasaLogo;
